<template>
  <div>
    <span class="caption font-weight-light">
      {{ label }}
    </span>
    <v-card
      class="d-flex"
      rounded="xl"
      style="position: relative;"
    >
      <div class="text-color-arrow">
        <translator
          x-axis="-100%"
          :translated="value === 'black'"
        >
          <rotator
            :state-one="90"
            :state-two="-90"
            :rotated="value === 'black'"
          >
            <v-icon 
              class="black--text"
              :class="{'white--text': value === 'white'}"
            >
              mdi-chevron-up
            </v-icon>
          </rotator>
        </translator>
      </div>
      <div
        v-if="value === 'black'"
        class="text-color-arrow"
        @click="$emit('input', 'white')"
      >
        <v-icon class="transparent--text right-facing">
          mdi-chevron-up
        </v-icon>
      </div>
      <v-btn
        large
        elevation="0"
        color="grey lighten-4"
        class="font-weight-bold option-button tile-right"
        @click="$emit('input', 'black')"
      >
        B
      </v-btn>
      <v-btn
        large
        tile
        elevation="0"
        color="grey darken-3"
        class="font-weight-bold white--text option-button tile-left"
        @click="$emit('input', 'white')"
      >
        W
      </v-btn>
    </v-card>
  </div>
</template>

<script>
import Rotator from '@/ft-vue-core/components/transformers/Rotator'
import Translator from '@/ft-vue-core/components/transformers/Translator'
export default {
  name: 'TextColorSelector',
  components: {Rotator, Translator},
  props: {
    value: String,
    label: String,
  },
  data () {
    return {}
  }
}
</script>

<style scoped>
.text-color-arrow {
  position: absolute;
  z-index: 2;
  top: 50%;
  left: 50%;
  cursor: pointer;
  transform: translateY(-50%);
}
.right-facing {
  transform: rotate(90deg);
}
.left-facing {
  transform: translateX(-100%) rotate(-90deg);
}
.option-button {
  border-radius: inherit;
}
.tile-right {
  border-top-right-radius: 0px;
  border-bottom-right-radius: 0px;
}
.tile-left {
  border-top-left-radius: 0px;
  border-bottom-left-radius: 0px;
}
</style>